import CodeChip from "@components/code-chip";
import { useState } from "react";
import EditGraphicModal from "./edit-form";
import { GraphicCardProp, IGraphic } from "src/types/graphic";

interface IGraphicsProps {
  graphic: IGraphic;
  onGraphicChange: (val: boolean) => void;
  IsGraphicSelected: boolean;
}

// interface GraphicCardProp {
//   title: string;
//   code: string;
//   description: string;
//   keyWords: string[];
//   url: string;
//   onGraphicChange: (val: boolean) => void;
//   IsGraphicSelected: boolean;
// }

export default function GraphicCard({
  graphic,
  IsGraphicSelected,
  onGraphicChange,
}: IGraphicsProps) {
  const { id, title, code, description, keyWords, url } = graphic ?? {};
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-md p-4 flex flex-col justify-between">
        <div className="mb-4">
          <CodeChip code={code} />
        </div>

        <div className="w-full h-48 bg-gray-100 border border-gray-300 rounded-lg flex items-center justify-center overflow-hidden">
          <img src={url} alt={title} className="object-contain w-full h-full" />
        </div>

        <h2 className="font-bold text-lg text-gray-800 mt-4">{title}</h2>
        <p className="text-sm text-gray-600 mt-1">
          {description || "No description provided."}
        </p>

        <div className="mt-3 flex flex-wrap gap-2">
          {keyWords.map((tag, i) => (
            <span
              key={i}
              className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>

        <button
          onClick={() => onGraphicChange(!IsGraphicSelected)}
          className={`mt-3 text-sm px-3 py-1 rounded transition ${
            IsGraphicSelected ? "bg-gray-400 text-white" : "bg-brand text-white"
          }`}
        >
          {IsGraphicSelected ? "Hide Details" : "View Details"}
        </button>
      </div>

      {IsGraphicSelected && (
        <aside className="fixed right-0 top-0 h-full w-96 bg-white shadow-lg p-6 z-50 overflow-y-auto">
          <button
            onClick={() => onGraphicChange(false)}
            className="text-sm font-semibold text-black hover:text-gray-700 mb-4"
          >
            Close
          </button>

          <h2 className="text-base font-semibold mb-4">Graphic Details</h2>

          <div className="w-full h-48 mb-3 bg-gray-100 border border-gray-300 rounded-lg flex items-center justify-center overflow-hidden">
            <img
              src={url}
              alt={title}
              className="object-contain w-full h-full"
            />
          </div>

          <p className="mb-2">
            <span className="font-semibold">Code:</span> {code}
          </p>
          <p className="mb-2">
            <span className="font-semibold">Title:</span> {title}
          </p>
          <p className="mb-2">
            <span className="font-semibold">Description:</span> {description}
          </p>
          <p className="mb-4 flex flex-col">
            <span className="font-semibold">keywords:</span>
            <div className="mt-3 flex flex-wrap gap-2">
              {keyWords.map((tag, i) => (
                <span
                  key={i}
                  className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </p>

          <button
            onClick={() => setIsModalOpen(true)}
            className="px-4 py-2 bg-brand text-white rounded"
          >
            Edit Graphic
          </button>

          {isModalOpen && (
            <EditGraphicModal
              description={description}
              graphicsKeywords={keyWords}
              id={id}
              setIsModalOpen={setIsModalOpen}
            />
          )}
        </aside>
      )}
    </>
  );
}
